import { PIEVE_THREAD_TYPES } from '@/lib/threads/threadTypeValues.js';

const THREAD_TYPE_VALUES = new Set(PIEVE_THREAD_TYPES);

const normalizeThreadType = (value, fallback = 'default') => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  if (!normalized) {
    return fallback;
  }

  if (THREAD_TYPE_VALUES.has(normalized)) {
    return normalized;
  }

  return fallback;
};

export default normalizeThreadType;
